import { render, staticRenderFns } from "./gdpr-file-manager-view.vue?vue&type=template&id=2fc7bdbb&scoped=true"
import script from "./gdpr-file-manager-view.vue?vue&type=script&lang=js"
export * from "./gdpr-file-manager-view.vue?vue&type=script&lang=js"
import style0 from "./gdpr-file-manager-view.vue?vue&type=style&index=0&id=2fc7bdbb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc7bdbb",
  null
  
)

export default component.exports